import { Marker, MarkerProps } from "react-map-gl/maplibre";
// import BlackDrone from '@/assets/markers/drone/black-drone.svg'
import WhiteDrone from "@/assets/markers/drone/white-drone.svg";
import { Detection } from "@/store/detection-slice";
import React from "react";
import { useStore } from "@/store/store";
// import { Marker } from 'maplibre-gl'
// import AmberDrone from '../../assets/markers/drone/amber-drone.svg'
import BlueDrone from '@/assets/markers/drone/blue-drone.svg'
// import GreenDrone from '../../assets/markers/drone/green-drone.svg'
// import RedDrone from '../../assets/markers/drone/red-drone.svg'
import { DroneTrackingBox } from "./drone-tracking-box";

type DroneMarkerProps = {
  drone: Detection;
  action: () => void;
} & MarkerProps;

export const DroneMarkerComponent = ({
  drone,
  action,
  ...marker
}: DroneMarkerProps) => {
  const whiteDrone = new Image();
  whiteDrone.src = WhiteDrone;

  const blueDrone = new Image();
  blueDrone.src = BlueDrone;

  const isTracked = useStore(state => state.trackedDroneId === drone.drone_identifier)
  

  const droneMarker = isTracked ? blueDrone : whiteDrone

  return (
    <Marker
      key={drone.drone_identifier}
      {...marker}
      element={droneMarker}
      anchor="center"
      onClick={() => {
        action();
      }}
    >
      <div className="relative">
        <img src={droneMarker.src} alt="Marker" style={{ width: 30, height: 30 }} />
        {isTracked && (
          <DroneTrackingBox 
            drone={drone} 
            isTracked={isTracked} 
          />
        )}
      </div>
    </Marker>
  );
};

export const DroneMarker = React.memo(DroneMarkerComponent);
